var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpaceshipBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 272 455.15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#D\xE9grad\xE9_sans_nom_65-4);}.cls-2{fill:#ddd;}.cls-3{fill:url(#D\xE9grad\xE9_sans_nom_31-4);}.cls-3,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9,.cls-10{mix-blend-mode:overlay;}.cls-11,.cls-12,.cls-13,.cls-14{fill:none;stroke-miterlimit:10;}.cls-11,.cls-12,.cls-14{stroke:#afafaf;}.cls-11,.cls-14{opacity:.8;}.cls-15{fill:#727272;}.cls-4{fill:url(#D\xE9grad\xE9_sans_nom_31-3);}.cls-5{fill:url(#D\xE9grad\xE9_sans_nom_31-6);}.cls-16{fill:url(#D\xE9grad\xE9_sans_nom_65-6);}.cls-17,.cls-18{fill:#fff;}.cls-17,.cls-19,.cls-20,.cls-21,.cls-22{opacity:.3;}.cls-23{fill:#a0a0a0;}.cls-24{isolation:isolate;}.cls-25{fill:#f92323;}.cls-18,.cls-26{opacity:.5;}.cls-6{fill:url(#D\xE9grad\xE9_sans_nom_31-5);}.cls-27{fill:#232323;}.cls-28{fill:#e0e0e0;}.cls-7{fill:url(#D\xE9grad\xE9_sans_nom_31-2);}.cls-29{fill:url(#D\xE9grad\xE9_sans_nom_65-2);}.cls-30{fill:#333;}.cls-19{fill:url(#D\xE9grad\xE9_sans_nom_75);}.cls-19,.cls-20,.cls-21,.cls-22,.cls-26{mix-blend-mode:multiply;}.cls-31{fill:#969696;}.cls-32{fill:url(#D\xE9grad\xE9_sans_nom_101-2);}.cls-33{fill:url(#D\xE9grad\xE9_sans_nom_65);}.cls-8{fill:#4b9cff;opacity:.54;}.cls-20,.cls-26{fill:#5c7784;}.cls-34{fill:url(#D\xE9grad\xE9_sans_nom_101-3);}.cls-35{fill:#aaa;}.cls-36{fill:#afafaf;}.cls-13{stroke:#a0a0a0;}.cls-37{fill:url(#D\xE9grad\xE9_sans_nom_101);}.cls-38{fill:#e8e8e8;}.cls-39{fill:#9b9b9b;}.cls-40{fill:#ccc;}.cls-41{fill:#d7f1ff;mix-blend-mode:screen;opacity:.2;}.cls-21{fill:url(#D\xE9grad\xE9_sans_nom_75-3);}.cls-42{fill:url(#D\xE9grad\xE9_sans_nom_101-4);}.cls-43{fill:url(#D\xE9grad\xE9_sans_nom_65-8);}.cls-14{stroke-width:1.49px;}.cls-44{fill:url(#D\xE9grad\xE9_sans_nom_65-7);}.cls-9{fill:url(#D\xE9grad\xE9_sans_nom_31-7);}.cls-45{fill:url(#D\xE9grad\xE9_sans_nom_101-5);}.cls-46{fill:url(#D\xE9grad\xE9_sans_nom_65-3);}.cls-10{fill:url(#D\xE9grad\xE9_sans_nom_31);}.cls-22{fill:url(#D\xE9grad\xE9_sans_nom_75-2);}.cls-47{fill:url(#D\xE9grad\xE9_sans_nom_65-5);}.cls-48{fill:#5e5e5e;}.cls-49{fill:url(#D\xE9grad\xE9_sans_nom_101-6);}"), /*#__PURE__*/React.createElement("radialGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_65",
    cx: 39.44,
    cy: 42.85,
    fx: 39.44,
    fy: 42.85,
    r: 1.78,
    gradientTransform: "translate(2.01 -1.77) rotate(2.63)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fcee21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#fcee24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#fcef2f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#fcf041"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#fcf25a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#fdf47b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#fdf7a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#fefbd1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_65-2",
    cx: 47.44,
    cy: 109.85,
    fx: 47.44,
    fy: 109.85,
    gradientTransform: "translate(5.1 -2.06) rotate(2.63)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_65"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_65-3",
    cx: 101.44,
    cy: 222.85,
    fx: 101.44,
    fy: 222.85,
    r: 1.78,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_65"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_65-4",
    cx: 101.44,
    cy: 257.85,
    fx: 101.44,
    fy: 257.85,
    r: 1.78,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_65"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_101",
    cx: 104.12,
    cy: 418.76,
    fx: 104.12,
    fy: 418.76,
    r: 5.74,
    gradientTransform: "translate(0 302.41) scale(1 .28)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbb03b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#faab39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#f99f36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#f68b31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#f36f29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#f15a24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#f05824"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#f05124"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#ef4524"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#ee3424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#ed1f24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#ed1c24"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_101-2",
    cx: 119.94,
    cy: 414.18,
    fx: 119.94,
    fy: 414.18,
    r: 6.34,
    gradientTransform: "translate(0 299.1) scale(1 .28)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_101"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_101-3",
    cx: 87.94,
    cy: 414.18,
    fx: 87.94,
    fy: 414.18,
    r: 6.34,
    gradientTransform: "translate(0 299.1) scale(1 .28)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_101"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_31",
    x1: 6.48,
    y1: 204.72,
    x2: 8.48,
    y2: 204.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bfbfbf",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#929292",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#4e4e4e",
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#262626",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#1c1c1c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_31-2",
    x1: 19.48,
    y1: 68.72,
    x2: 21.48,
    y2: 68.72,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_31"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_31-3",
    x1: 6.48,
    y1: 377.22,
    x2: 8.48,
    y2: 377.22,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_31"
  }), /*#__PURE__*/React.createElement("symbol", {
    id: "spaceship",
    viewBox: "0 0 136.44 455"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-33",
    cx: 39.44,
    cy: 42.85,
    rx: 2.09,
    ry: 1.39,
    transform: "translate(-1.93 1.86) rotate(-2.63)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-29",
    cx: 47.44,
    cy: 109.85,
    rx: 2.09,
    ry: 1.39,
    transform: "translate(-5 2.29) rotate(-2.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "m103.53,222.85c0,.77-.94,1.39-2.09,1.39s-2.09-.62-2.09-1.39.94-1.39,2.09-1.39,2.09.62,2.09,1.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m103.53,257.85c0,.77-.94,1.39-2.09,1.39s-2.09-.62-2.09-1.39.94-1.39,2.09-1.39,2.09.62,2.09,1.39Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "51.28 140.32 .44 140.32 .44 25.32 38.28 25.32 38.33 25.87 38.35 26 48.15 112.67 51.28 140.32"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "m131.94,275.74v120.76h-58v-122c2.18-2.05,12.92-11.69,29.5-11.5.61.01,1.22.03,1.81.07,13.32.72,22.37,7.62,25.73,10.56.62.53.96,1.3.96,2.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "m136.44,408c0,5.52-14.77,10-33,10s-33-4.48-33-10c0-3.59,6.25-6.74,15.63-8.5,5.05-.95,10.99-1.5,17.37-1.5s12.32.55,17.37,1.5c9.38,1.76,15.63,4.91,15.63,8.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "m136.44,391v17c0-3.59-6.25-6.74-15.63-8.5-5.05-.95-10.99-1.5-17.37-1.5s-12.32.55-17.37,1.5c-9.38,1.76-15.63,4.91-15.63,8.5v-17c0-5.52,14.77-10,33-10s33,4.48,33,10Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m114.03,414.46c.3-.36.45-.74.45-1.13,0-2.16-4.72-3.9-10.54-3.9s-10.54,1.75-10.54,3.9c0,.39.16.77.45,1.13-.79-.69-1.23-1.47-1.23-2.3,0-2.8,5.07-5.08,11.32-5.08s11.32,2.27,11.32,5.08c0,.84-.45,1.62-1.23,2.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "m114.48,413.33l-.04.34-.74,5.13h-19.52l-.74-5.13-.04-.34c0-2.16,4.72-3.9,10.54-3.9s10.54,1.75,10.54,3.9Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-40",
    cx: 103.94,
    cy: 418.8,
    rx: 9.76,
    ry: 3.12
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-30",
    cx: 103.94,
    cy: 418.8,
    rx: 8.98,
    ry: 2.34
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-37",
    cx: 104.12,
    cy: 418.76,
    rx: 7.92,
    ry: 1.82
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m105.25,408.99l-.46,6.79c-.28-.02-.56-.02-.85-.02h-.22l-.45-6.79c.22-.01.45-.01.67-.01.44,0,.88.01,1.31.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m102.25,409.01l-.46,6.82c-.36.02-.72.05-1.06.09l-.45-6.74c.63-.08,1.29-.14,1.97-.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m99.23,409.33l-.46,6.86c-.34.06-.68.13-1,.2l-.45-6.65c.59-.16,1.23-.3,1.91-.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m96.18,410.08l-.47,6.93c-.32.12-.62.26-.88.39l-.43-6.55c.51-.28,1.11-.54,1.78-.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m108.23,409.27l-.45,6.72c-.34-.04-.69-.08-1.05-.11l-.46-6.83c.68.05,1.33.12,1.96.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m111.19,409.92l-.45,6.63c-.31-.09-.64-.17-.98-.23l-.46-6.87c.67.13,1.31.28,1.89.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m112.36,410.32c.68.27,1.27.58,1.74.91l-.44,6.56c-.24-.17-.51-.34-.83-.49l-.47-6.98Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m130.92,409.46c.32-.39.49-.81.49-1.23,0-.72-.47-1.39-1.31-1.98-.47-.33-1.06-.64-1.74-.91-.36-.14-.75-.28-1.17-.4-.58-.19-1.22-.34-1.89-.47-.34-.07-.7-.13-1.07-.18-.63-.1-1.28-.17-1.96-.22l.46,6.83c-.63-.06-1.27-.09-1.94-.1l.46-6.79c-.43-.02-.87-.03-1.31-.03-.22,0-.45,0-.67.01-.34,0-.68.02-1.02.04-.68.03-1.34.09-1.97.17-.36.04-.71.09-1.05.15-.68.11-1.32.25-1.91.41-.4.1-.78.21-1.14.34-.67.23-1.27.49-1.78.77-1.22.67-1.93,1.48-1.93,2.36,0,.42.17.84.49,1.23-.86-.75-1.34-1.6-1.34-2.51,0-3.05,5.51-5.52,12.32-5.52,4.23,0,7.96.95,10.18,2.42.05.02.09.05.13.09,1.27.86,2.01,1.9,2.01,3.01,0,.91-.48,1.76-1.34,2.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "m131.41,408.23l-.04.37-.81,5.58h-21.24l-.81-5.58-.04-.37c0-2.35,5.13-4.25,11.47-4.25s11.47,1.9,11.47,4.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "m130.56,414.18c0,1.87-4.76,3.4-10.62,3.4s-10.62-1.53-10.62-3.4c0-.64.55-1.24,1.51-1.76.26-.13.56-.27.88-.39.6-.23,1.29-.44,2.06-.62.32-.07.66-.14,1-.2.62-.11,1.27-.2,1.96-.27.34-.04.7-.07,1.06-.09.62-.04,1.27-.06,1.93-.07h.22c.29,0,.57,0,.85.02.67,0,1.31.04,1.94.1.36.03.71.07,1.05.11.7.09,1.36.19,1.98.33.34.06.67.14.98.23.81.21,1.51.47,2.09.75.32.15.59.32.83.49.58.42.9.88.9,1.37Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-30",
    cx: 119.94,
    cy: 414.18,
    rx: 9.77,
    ry: 2.55
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-32",
    cx: 119.94,
    cy: 414.18,
    rx: 8.74,
    ry: 2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m121.25,404.01l-.46,6.79c-.28-.02-.56-.02-.85-.02h-.22l-.45-6.79c.22-.01.45-.01.67-.01.44,0,.88.01,1.31.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m118.25,404.03l-.46,6.82c-.36.02-.72.05-1.06.09l-.45-6.74c.63-.08,1.29-.14,1.97-.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m115.23,404.35l-.46,6.86c-.34.06-.68.13-1,.2l-.45-6.65c.59-.16,1.23-.3,1.91-.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m112.18,405.1l-.47,6.93c-.32.12-.62.26-.88.39l-.43-6.55c.51-.28,1.11-.54,1.78-.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m124.23,404.29l-.45,6.72c-.34-.04-.69-.08-1.05-.11l-.46-6.83c.68.05,1.33.12,1.96.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m127.19,404.94l-.45,6.63c-.31-.09-.64-.17-.98-.23l-.46-6.87c.67.13,1.31.28,1.89.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m128.36,405.34c.68.27,1.27.58,1.74.91l-.44,6.56c-.24-.17-.51-.34-.83-.49l-.47-6.98Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m98.92,409.46c.32-.39.49-.81.49-1.23,0-2.35-5.13-4.25-11.47-4.25s-11.47,1.9-11.47,4.25c0,.42.17.84.49,1.23-.86-.75-1.34-1.6-1.34-2.51,0-3.05,5.52-5.52,12.32-5.52s12.32,2.47,12.32,5.52c0,.91-.48,1.76-1.34,2.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "m99.41,408.23l-.04.37-.81,5.58h-21.24l-.81-5.58-.04-.37c0-2.35,5.13-4.25,11.47-4.25s11.47,1.9,11.47,4.25Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-40",
    cx: 87.94,
    cy: 414.18,
    rx: 10.62,
    ry: 3.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-30",
    cx: 87.94,
    cy: 414.18,
    rx: 9.77,
    ry: 2.55
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m89.25,403.99l-.46,6.79c-.28-.02-.56-.02-.85-.02h-.22l-.45-6.79c.22-.01.45-.01.67-.01.44,0,.88.01,1.31.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m86.25,404.01l-.46,6.82c-.36.02-.72.05-1.06.09l-.45-6.74c.63-.08,1.29-.14,1.97-.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m83.23,404.33l-.46,6.86c-.34.06-.68.13-1,.2l-.45-6.65c.59-.16,1.23-.3,1.91-.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m80.18,405.08l-.47,6.93c-.32.12-.62.26-.88.39l-.43-6.55c.51-.28,1.11-.54,1.78-.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m92.23,404.27l-.45,6.72c-.34-.04-.69-.08-1.05-.11l-.46-6.83c.68.05,1.33.12,1.96.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m95.19,404.92l-.45,6.63c-.31-.09-.64-.17-.98-.23l-.46-6.87c.67.13,1.31.28,1.89.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m96.36,405.32c.68.27,1.27.58,1.74.91l-.44,6.56c-.24-.17-.51-.34-.83-.49l-.47-6.98Z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-34",
    cx: 87.94,
    cy: 414.18,
    rx: 8.74,
    ry: 2
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 117.53,
    y1: 266.34,
    x2: 117.53,
    y2: 372.85
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m131.94,293.07v16.01c-7.21-6-17.5-9.74-28.91-9.74s-21.87,3.8-29.09,9.87v-15.89l2.43-1.98c7.03-4.97,16.38-8,26.66-8s19.63,3.03,26.66,8c.78.55,1.53,1.12,2.25,1.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m131.94,365.07v16.01c-7.21-6-17.5-9.74-28.91-9.74s-21.87,3.8-29.09,9.87v-15.89l2.43-1.98c7.03-4.97,16.38-8,26.66-8s19.63,3.03,26.66,8c.78.55,1.53,1.12,2.25,1.73Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "122.03 340.84 110.03 337.84 110.03 307.84 122.03 310.84 122.03 340.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "122.03 310.84 122.03 340.84 120.53 340.47 120.53 312.5 110.03 309.72 110.03 307.84 122.03 310.84"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-23",
    cx: 120.53,
    cy: 276.34,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-23",
    cx: 120.53,
    cy: 284.34,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-23",
    cx: 120.53,
    cy: 344.34,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-23",
    cx: 120.53,
    cy: 353.34,
    r: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "73.94 280.17 76.68 280.17 76.47 352.33 73.94 360.48 73.94 280.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m105.25,263.07v7.26l-11.07,15h-12.65v-11.46s-6,2.01-7.59,5.55v-4.92c2.18-2.05,12.92-11.69,29.5-11.5.61.01,1.22.03,1.81.07Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "85.44 213 47.77 213.25 37.53 213.32 32.53 213.35 .44 213.56 .44 140.32 51.28 140.32 51.62 141.04 65.2 169.94 65.61 170.81 74.15 188.98 74.56 189.85 84.55 211.11 85.44 213"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "m101.44,220v48.69c0,.68-.23,1.34-.66,1.86l-8.61,10.56c-.46.56-1.15.89-1.88.89h-4.47c-.76,0-1.38-.62-1.38-1.38v-12.3H.44v-56.2l32.09-.39,5-.06,10.25-.12,36.66-.44h.11l7.65-.09c.79,0,1.55.32,2.07.91l7.17,8.07Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 0.44,
    y: 268,
    width: 74,
    height: 81
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "74.44 349 73.94 351.07 73.71 352.04 68.68 372.85 68.46 373.79 63.74 393.32 63.52 394.25 53.44 436 .44 436 .44 349 74.44 349"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "53.44 436 53.25 436.18 34.44 455 16.44 455 8.69 449.18 .44 449 .44 436 53.44 436"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "38.44 26 .44 26 .44 3 21.44 3 37.94 25.32 38.33 25.87 38.44 26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "21.44 3 .44 3 .44 0 17.44 0 21.44 3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "m34.53,32.5H.44V10.5h16.69c.24,0,.48.03.71.1.6.15,1.13.52,1.51,1.03l9.96,13.69.49.68,4.73,6.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "m30.53,31.5H.44V12.5h14.74c.77,0,1.5.37,1.96.98l8.8,11.84.5.68,4.09,5.5Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-14",
    points: ".44 416 28.41 416 32.53 416 37.03 416 37.53 415.4 47.03 404 47.24 349 47.25 348.57 47.37 315.58 47.56 268.32 47.56 268 47.77 213.25 47.78 211.55 48.03 147.5"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 17.84,
    y1: 0.5,
    x2: 17.84,
    y2: 10.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 0.44,
    y: 302.72,
    width: 20.04,
    height: 42
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 21.52,
    y1: 3.5,
    x2: 19.35,
    y2: 11.63
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 38.02,
    y1: 25.82,
    x2: 34.52,
    y2: 32.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-11",
    x1: 37.52,
    y1: 417.37,
    x2: 53.52,
    y2: 436.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m20.48,313.56c9.38.44,18.36,1.14,26.89,2.02,9.4.98,18.28,2.18,26.57,3.5.17.03.33.05.5.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m37.53,303.67v2c-5.52-.46-11.2-.84-17.05-1.11-6.49-.32-13.18-.5-20.04-.54v-2c11.2.06,21.9.51,32.09,1.26,1.68.12,3.35.25,5,.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m10.44,302.4v1.81c-3.28-.1-6.62-.16-10-.19v-1.8c3.39.02,6.72.08,10,.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m37.52,345.67v73c-1.41-.12-2.84-.23-4.27-.34-.24,0-.48-.03-.73-.05v-73c1.68.12,3.35.25,5,.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m32.53,416.28v2c-10.18-.74-20.89-1.2-32.09-1.26v-2c9.7.05,19.03.4,27.97.98,1.38.09,2.76.18,4.12.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m37.53,345.67v2c-1.65-.14-3.32-.27-5-.39-.01,0-.02-.01-.03,0-1.35-.1-2.72-.2-4.09-.28-1.38-.09-2.78-.18-4.18-.25-1.48-.09-2.96-.16-4.46-.23-1.34-.06-2.7-.12-4.05-.17-4.32-.16-8.72-.27-13.19-.32-.49-.01-.98-.01-1.48-.01H.44v-2c6.87.04,13.55.22,20.04.53,4.1.19,8.11.44,12.05.73,1.68.12,3.35.25,5,.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m32.53,112.28v2c-10.18-.74-20.89-1.2-32.09-1.26v-2c11.2.06,21.91.51,32.09,1.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m.43,110.01c17.09.11,33.05,1.11,47.71,2.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m.43,138.01c11.2.07,21.91.53,32.09,1.27,1.68.12,3.35.25,5,.39,2.43.2,4.83.41,7.2.65,2.33.23,4.62.47,6.89.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m.44,346.01c.2,0,.41,0,.61.01.5,0,.99,0,1.48.01,4.48.04,8.88.15,13.19.32,1.36.05,2.71.11,4.05.17,1.5.07,2.98.14,4.46.23,1.4.07,2.8.16,4.18.25,1.37.08,2.74.18,4.09.28.01-.01.02,0,.03,0,1.68.12,3.35.25,5,.39,3.3.27,6.54.57,9.72.9,1.35.14,2.68.28,4.01.43,7.88.88,15.38,1.92,22.45,3.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "m32.53,112.28v191c-10.18-.75-20.89-1.2-32.09-1.26V111.02c11.2.06,21.91.51,32.09,1.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "m32.53,44.5v55c-11-1-19.93-1.99-32-2h-.09v-53h32.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m37.52,112.67v192.83l-5-2V112.28c1.14.08,2.28.17,3.4.26.54.04,1.07.09,1.6.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "m32.53,345.28v73c-10.19-.74-20.89-1.2-32.09-1.26v-73c6.87.04,13.55.22,20.04.53,4.1.19,8.11.44,12.05.73Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "40.53 445.5 .44 445.5 .44 422.5 32.53 422.5 37.23 436 40.53 445.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "38.53 445.18 .44 445.18 .44 423.5 30.75 423.5 31.1 424.5 32.19 427.5 32.54 428.5 33.25 430.5 33.61 431.5 34.7 434.5 35.06 435.5 35.42 436.5 35.77 437.5 36.12 438.5 36.49 439.5 37.56 442.5 37.93 443.5 38.53 445.18"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 0.44,
    y: 32.5,
    width: 36.09,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 0.44,
    y: 445.5,
    width: 40.09,
    height: 2
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "38.67 449.5 33.26 454.5 17.52 454.5 10.52 449.5 38.67 449.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "33.41 449.5 31.79 454.5 29.31 454.5 30.93 449.5 33.41 449.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "29.41 449.5 27.79 454.5 26.31 454.5 27.93 449.5 29.41 449.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "28.94 425.5 .44 425.5 .44 424.5 28.6 424.5 28.94 425.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "29.64 427.5 .44 427.5 .44 426.5 29.29 426.5 29.64 427.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "30.31 429.5 .44 429.5 .44 428.5 29.96 428.5 30.31 429.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "31 431.5 .44 431.5 .44 430.5 30.65 430.5 31 431.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "31.68 433.5 .44 433.5 .44 432.5 31.34 432.5 31.68 433.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "32.37 435.5 .44 435.5 .44 434.5 32.03 434.5 32.37 435.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "33.05 437.5 .44 437.5 .44 436.5 32.72 436.5 33.05 437.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "33.74 439.5 .44 439.5 .44 438.5 33.39 438.5 33.74 439.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "34.42 441.5 .44 441.5 .44 440.5 34.08 440.5 34.42 441.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "35.11 443.5 .44 443.5 .44 442.5 34.77 442.5 35.11 443.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "m101.53,231.34v15h-4.5c-4.01,0-7.29-3.15-7.48-7.11-.02-.13-.02-.26-.02-.39,0-2.07.84-3.94,2.2-5.3,1.36-1.36,3.23-2.2,5.3-2.2h4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m97.03,231.34h4.5v1.72h-5.36c-3.51,0-6.38,2.72-6.62,6.17-.02-.13-.02-.26-.02-.39,0-2.07.84-3.94,2.2-5.3,1.36-1.36,3.23-2.2,5.3-2.2Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 101.53,
    y1: 220.34,
    x2: 74.53,
    y2: 220.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 101.53,
    y1: 260.84,
    x2: 74.53,
    y2: 260.84
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "37.53 259.61 37.53 275.61 32.53 274.07 32.53 258.07 37.53 259.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "37.53 230.11 37.53 246.11 32.53 244.57 32.53 228.57 37.53 230.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "37.53 200.61 37.53 216.61 32.53 215.07 32.53 199.07 37.53 200.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "37.53 171.11 37.53 187.11 32.53 185.57 32.53 169.57 37.53 171.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "37.53 141.61 37.53 157.61 32.53 156.07 32.53 140.07 37.53 141.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "37.53 141.61 37.53 157.61 32.53 156.07 32.53 140.07 37.53 141.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "32.53 169.57 37.53 171.11 37.53 187.11 32.53 185.57 32.53 169.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "32.53 199.07 37.53 200.61 37.53 216.61 32.53 215.07 32.53 199.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "32.53 228.57 37.53 230.11 37.53 246.11 32.53 244.57 32.53 228.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "32.53 258.07 37.53 259.61 37.53 275.61 32.53 274.07 32.53 258.07"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-23",
    cx: 97.53,
    cy: 258.34,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-23",
    cx: 120.53,
    cy: 269.34,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-23",
    cx: 89.53,
    cy: 258.34,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-23",
    cx: 81.53,
    cy: 258.34,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-23",
    cx: 97.53,
    cy: 223.34,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-23",
    cx: 89.53,
    cy: 223.34,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-23",
    cx: 81.53,
    cy: 223.34,
    r: 1
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "33.53 99.84 32.53 99.84 32.53 44.84 33.53 45.84 33.53 99.84"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "74.56 189.85 65.47 194.25 55.89 174.45 65.2 169.94 65.61 170.81 57.2 174.88 65.95 192.95 74.15 188.98 74.56 189.85"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-36",
    cx: 60.34,
    cy: 175.62,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-36",
    cx: 67.53,
    cy: 190.47,
    r: 0.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "61.5 371.92 56.28 391.31 63.74 393.32 63.52 394.25 55.07 391.98 60.78 370.73 68.68 372.85 68.46 373.79 61.5 371.92"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-36",
    cx: 63.38,
    cy: 374.54,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-36",
    cx: 59.1,
    cy: 390.47,
    r: 0.5
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: ".44 295.72 6.48 295.72 8.48 295.72 8.48 268.32 8.48 268 8.48 213.51 8.48 212.02 8.48 140.32 8.48 138.12 8.48 113.72 6.48 113.72 .44 113.72 .44 295.72"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 6.48,
    y: 113.72,
    width: 2,
    height: 182
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 13.48,
    y: 47.72,
    width: 8,
    height: 42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 19.48,
    y: 47.72,
    width: 2,
    height: 42
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: ".44 406.72 6.48 406.72 8.48 406.72 8.48 349 8.48 347.72 6.48 347.72 .44 347.72 .44 406.72"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 6.48,
    y: 347.72,
    width: 2,
    height: 59
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m10.44,302.4v1.81c-3.28-.1-6.62-.16-10-.19v-1.8c3.39.02,6.72.08,10,.18Z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_65-5",
    cx: -8783,
    cy: -8440.5,
    fx: -8783,
    fy: -8440.5,
    r: 1.78,
    gradientTransform: "translate(-8737.98 -8343.08) rotate(-92.63) scale(1 -1)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_65"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_65-6",
    cx: -8775,
    cy: -8373.5,
    fx: -8775,
    fy: -8373.5,
    r: 1.78,
    gradientTransform: "translate(-8678.69 -8271.16) rotate(-92.63) scale(1 -1)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_65"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_65-7",
    cx: -8721,
    cy: -8260.5,
    fx: -8721,
    fy: -8260.5,
    r: 1.78,
    gradientTransform: "translate(-8686 8483.5) rotate(-180) scale(1 -1)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_65"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_65-8",
    cx: -8721,
    cy: -8225.5,
    fx: -8721,
    fy: -8225.5,
    r: 1.78,
    gradientTransform: "translate(-8686 8483.5) rotate(-180) scale(1 -1)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_65"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_101-4",
    cx: -8718.32,
    cy: -8064.59,
    fx: -8718.32,
    fy: -8064.59,
    r: 5.74,
    gradientTransform: "translate(-8686 2659.63) rotate(-180) scale(1 -.28)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_101"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_101-5",
    cx: -8702.5,
    cy: -8069.17,
    fx: -8702.5,
    fy: -8069.17,
    r: 6.34,
    gradientTransform: "translate(-8686 2656.32) rotate(-180) scale(1 -.28)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_101"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_101-6",
    cx: -8734.5,
    cy: -8069.17,
    fx: -8734.5,
    fy: -8069.17,
    r: 6.34,
    gradientTransform: "translate(-8686 2656.32) rotate(-180) scale(1 -.28)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_101"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_31-4",
    x1: -8815.96,
    y1: -8278.63,
    x2: -8813.96,
    y2: -8278.63,
    gradientTransform: "translate(8943.92 -8073.77) scale(1 -1)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_31"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_31-5",
    x1: -8802.96,
    y1: -8414.63,
    x2: -8800.96,
    y2: -8414.63,
    gradientTransform: "translate(8917.92 -8345.77) scale(1 -1)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_31"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_31-6",
    x1: -8815.96,
    y1: -8106.13,
    x2: -8813.96,
    y2: -8106.13,
    gradientTransform: "translate(8943.92 -7728.77) scale(1 -1)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_31"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_31-7",
    x1: 6.89,
    y1: 110.4,
    x2: 245.46,
    y2: 429.25,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_31"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_75",
    x1: 206,
    y1: 347.34,
    x2: 272,
    y2: 347.34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#f2f5f6",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#e6ebed",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#abb9c0",
    stopOpacity: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#7f959f",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#657f8b",
    stopOpacity: 0.94
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5c7784"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_75-2",
    x1: 0,
    y1: 368.38,
    x2: 66,
    y2: 368.38,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_75"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_75-3",
    x1: 90.35,
    y1: 292.7,
    x2: 281.05,
    y2: 391.96,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_75"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-24"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calque_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calque_2_-_copie"
  }, /*#__PURE__*/React.createElement("use", {
    width: 136.44,
    height: 455,
    transform: "translate(135.56 .15)",
    xlinkHref: "#spaceship"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-47",
    cx: 97,
    cy: 43,
    rx: 1.39,
    ry: 2.09,
    transform: "translate(49.6 137.92) rotate(-87.37)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-16",
    cx: 89,
    cy: 110,
    rx: 1.39,
    ry: 2.09,
    transform: "translate(-24.97 193.85) rotate(-87.37)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-44",
    cx: 35,
    cy: 223,
    rx: 2.09,
    ry: 1.39
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-43",
    cx: 35,
    cy: 258,
    rx: 2.09,
    ry: 1.39
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "85.16 140.47 136 140.47 136 25.47 98.16 25.47 98.1 26.02 98.08 26.15 88.29 112.82 85.16 140.47"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "m4.5,275.89v120.76h58v-122c-2.18-2.05-12.92-11.69-29.5-11.5-.61.01-1.22.03-1.81.07-13.32.72-22.37,7.62-25.73,10.56-.62.53-.96,1.3-.96,2.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "m0,408.15c0,5.52,14.77,10,33,10s33-4.48,33-10c0-3.59-6.25-6.74-15.63-8.5-5.05-.95-10.99-1.5-17.37-1.5s-12.32.55-17.37,1.5C6.25,401.41,0,404.56,0,408.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "m0,391.15v17c0-3.59,6.25-6.74,15.63-8.5,5.05-.95,10.99-1.5,17.37-1.5s12.32.55,17.37,1.5c9.38,1.76,15.63,4.91,15.63,8.5v-17c0-5.52-14.77-10-33-10S0,385.63,0,391.15Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m22.41,414.61c-.3-.36-.45-.74-.45-1.13,0-2.16,4.72-3.9,10.54-3.9s10.54,1.75,10.54,3.9c0,.39-.16.77-.45,1.13.79-.69,1.23-1.47,1.23-2.3,0-2.8-5.07-5.08-11.32-5.08s-11.32,2.27-11.32,5.08c0,.84.45,1.62,1.23,2.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "m21.96,413.48l.04.34.74,5.13h19.52l.74-5.13.04-.34c0-2.16-4.72-3.9-10.54-3.9s-10.54,1.75-10.54,3.9Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-40",
    cx: 32.5,
    cy: 418.95,
    rx: 9.76,
    ry: 3.12
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-30",
    cx: 32.5,
    cy: 418.95,
    rx: 8.98,
    ry: 2.34
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-42",
    cx: 32.32,
    cy: 418.91,
    rx: 7.92,
    ry: 1.82
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m31.19,409.14l.46,6.79c.28-.02.56-.02.85-.02h.22l.45-6.79c-.22-.01-.45-.01-.67-.01-.44,0-.88.01-1.31.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m34.19,409.16l.46,6.82c.36.02.72.05,1.06.09l.45-6.74c-.63-.08-1.29-.14-1.97-.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m37.21,409.48l.46,6.86c.34.06.68.13,1,.2l.45-6.65c-.59-.16-1.23-.3-1.91-.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m40.26,410.23l.47,6.93c.32.12.62.26.88.39l.43-6.55c-.51-.28-1.11-.54-1.78-.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m28.21,409.42l.45,6.72c.34-.04.69-.08,1.05-.11l.46-6.83c-.68.05-1.33.12-1.96.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m25.25,410.07l.45,6.63c.31-.09.64-.17.98-.23l.46-6.87c-.67.13-1.31.28-1.89.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m24.08,410.47c-.68.27-1.27.58-1.74.91l.44,6.56c.24-.17.51-.34.83-.49l.47-6.98Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m5.52,409.61c-.32-.39-.49-.81-.49-1.23,0-.72.47-1.39,1.31-1.98.47-.33,1.06-.64,1.74-.91.36-.14.75-.28,1.17-.4.58-.19,1.22-.34,1.89-.47.34-.07.7-.13,1.07-.18.63-.1,1.28-.17,1.96-.22l-.46,6.83c.63-.06,1.27-.09,1.94-.1l-.46-6.79c.43-.02.87-.03,1.31-.03.22,0,.45,0,.67.01.34,0,.68.02,1.02.04.68.03,1.34.09,1.97.17.36.04.71.09,1.05.15.68.11,1.32.25,1.91.41.4.1.78.21,1.14.34.67.23,1.27.49,1.78.77,1.22.67,1.93,1.48,1.93,2.36,0,.42-.17.84-.49,1.23.86-.75,1.34-1.6,1.34-2.51,0-3.05-5.51-5.52-12.32-5.52-4.23,0-7.96.95-10.18,2.42-.05.02-.09.05-.13.09-1.27.86-2.01,1.9-2.01,3.01,0,.91.48,1.76,1.34,2.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "m5.03,408.38l.04.37.81,5.58h21.24l.81-5.58.04-.37c0-2.35-5.13-4.25-11.47-4.25s-11.47,1.9-11.47,4.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "m5.88,414.33c0,1.87,4.76,3.4,10.62,3.4s10.62-1.53,10.62-3.4c0-.64-.55-1.24-1.51-1.76-.26-.13-.56-.27-.88-.39-.6-.23-1.29-.44-2.06-.62-.32-.07-.66-.14-1-.2-.62-.11-1.27-.2-1.96-.27-.34-.04-.7-.07-1.06-.09-.62-.04-1.27-.06-1.93-.07h-.22c-.29,0-.57,0-.85.02-.67,0-1.31.04-1.94.1-.36.03-.71.07-1.05.11-.7.09-1.36.19-1.98.33-.34.06-.67.14-.98.23-.81.21-1.51.47-2.09.75-.32.15-.59.32-.83.49-.58.42-.9.88-.9,1.37Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-30",
    cx: 16.5,
    cy: 414.33,
    rx: 9.77,
    ry: 2.55
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-45",
    cx: 16.5,
    cy: 414.33,
    rx: 8.74,
    ry: 2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m15.19,404.16l.46,6.79c.28-.02.56-.02.85-.02h.22l.45-6.79c-.22-.01-.45-.01-.67-.01-.44,0-.88.01-1.31.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m18.19,404.18l.46,6.82c.36.02.72.05,1.06.09l.45-6.74c-.63-.08-1.29-.14-1.97-.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m21.21,404.5l.46,6.86c.34.06.68.13,1,.2l.45-6.65c-.59-.16-1.23-.3-1.91-.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m24.26,405.25l.47,6.93c.32.12.62.26.88.39l.43-6.55c-.51-.28-1.11-.54-1.78-.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m12.21,404.44l.45,6.72c.34-.04.69-.08,1.05-.11l.46-6.83c-.68.05-1.33.12-1.96.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m9.25,405.09l.45,6.63c.31-.09.64-.17.98-.23l.46-6.87c-.67.13-1.31.28-1.89.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m8.08,405.49c-.68.27-1.27.58-1.74.91l.44,6.56c.24-.17.51-.34.83-.49l.47-6.98Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m37.52,409.61c-.32-.39-.49-.81-.49-1.23,0-2.35,5.13-4.25,11.47-4.25s11.47,1.9,11.47,4.25c0,.42-.17.84-.49,1.23.86-.75,1.34-1.6,1.34-2.51,0-3.05-5.52-5.52-12.32-5.52s-12.32,2.47-12.32,5.52c0,.91.48,1.76,1.34,2.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "m37.03,408.38l.04.37.81,5.58h21.24l.81-5.58.04-.37c0-2.35-5.13-4.25-11.47-4.25s-11.47,1.9-11.47,4.25Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-40",
    cx: 48.5,
    cy: 414.33,
    rx: 10.62,
    ry: 3.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-30",
    cx: 48.5,
    cy: 414.33,
    rx: 9.77,
    ry: 2.55
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m47.19,404.14l.46,6.79c.28-.02.56-.02.85-.02h.22l.45-6.79c-.22-.01-.45-.01-.67-.01-.44,0-.88.01-1.31.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m50.19,404.16l.46,6.82c.36.02.72.05,1.06.09l.45-6.74c-.63-.08-1.29-.14-1.97-.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m53.21,404.48l.46,6.86c.34.06.68.13,1,.2l.45-6.65c-.59-.16-1.23-.3-1.91-.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m56.26,405.23l.47,6.93c.32.12.62.26.88.39l.43-6.55c-.51-.28-1.11-.54-1.78-.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m44.21,404.42l.45,6.72c.34-.04.69-.08,1.05-.11l.46-6.83c-.68.05-1.33.12-1.96.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m41.25,405.07l.45,6.63c.31-.09.64-.17.98-.23l.46-6.87c-.67.13-1.31.28-1.89.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m40.08,405.47c-.68.27-1.27.58-1.74.91l.44,6.56c.24-.17.51-.34.83-.49l.47-6.98Z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-49",
    cx: 48.5,
    cy: 414.33,
    rx: 8.74,
    ry: 2
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 18.91,
    y1: 266.49,
    x2: 18.91,
    y2: 373
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m4.5,293.22v16.01c7.21-6,17.5-9.74,28.91-9.74s21.87,3.8,29.09,9.87v-15.89l-2.43-1.98c-7.03-4.97-16.38-8-26.66-8s-19.63,3.03-26.66,8c-.78.55-1.53,1.12-2.25,1.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m4.5,365.22v16.01c7.21-6,17.5-9.74,28.91-9.74s21.87,3.8,29.09,9.87v-15.89l-2.43-1.98c-7.03-4.97-16.38-8-26.66-8s-19.63,3.03-26.66,8c-.78.55-1.53,1.12-2.25,1.73Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "14.41 340.99 26.41 337.99 26.41 307.99 14.41 310.99 14.41 340.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "14.41 310.99 14.41 340.99 15.91 340.62 15.91 312.65 26.41 309.87 26.41 307.99 14.41 310.99"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-23",
    cx: 15.91,
    cy: 276.49,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-23",
    cx: 15.91,
    cy: 284.49,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-23",
    cx: 15.91,
    cy: 344.49,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-23",
    cx: 15.91,
    cy: 353.49,
    r: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "62.5 280.32 59.76 280.32 59.97 352.48 62.5 360.63 62.5 280.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m31.19,263.22v7.26l11.07,15h12.65v-11.46s6,2.01,7.59,5.55v-4.92c-2.18-2.05-12.92-11.69-29.5-11.5-.61.01-1.22.03-1.81.07Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "51 213.15 88.67 213.4 98.91 213.47 103.91 213.5 136 213.71 136 140.47 85.16 140.47 84.82 141.19 71.24 170.09 70.83 170.96 62.29 189.13 61.88 190 51.89 211.26 51 213.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "m35,220.15v48.69c0,.68.23,1.34.66,1.86l8.61,10.56c.46.56,1.15.89,1.88.89h4.47c.76,0,1.38-.62,1.38-1.38v-12.3h84v-56.2l-32.09-.39-5-.06-10.25-.12-36.66-.44h-.11l-7.65-.09c-.79,0-1.55.32-2.07.91l-7.17,8.07Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 62,
    y: 268.15,
    width: 74,
    height: 81
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "62 349.15 62.5 351.22 62.73 352.19 67.76 373 67.98 373.94 72.7 393.47 72.92 394.4 83 436.15 136 436.15 136 349.15 62 349.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "83 436.15 83.18 436.33 102 455.15 120 455.15 127.75 449.33 136 449.15 136 436.15 83 436.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "98 26.15 136 26.15 136 3.15 115 3.15 98.5 25.47 98.1 26.02 98 26.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "115 3.15 136 3.15 136 .15 119 .15 115 3.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "m101.91,32.65h34.09V10.65h-16.69c-.24,0-.48.03-.71.1-.6.15-1.13.52-1.51,1.03l-9.96,13.69-.49.68-4.73,6.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "m105.91,31.65h30.09V12.65h-14.74c-.77,0-1.5.37-1.96.98l-8.8,11.84-.5.68-4.09,5.5Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-14",
    points: "136 416.15 108.03 416.15 103.91 416.15 99.41 416.15 98.91 415.55 89.41 404.15 89.2 349.15 89.19 348.72 89.07 315.73 88.88 268.47 88.88 268.15 88.67 213.4 88.66 211.7 88.41 147.65"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 118.6,
    y1: 0.65,
    x2: 118.6,
    y2: 10.75
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 115.96,
    y: 302.87,
    width: 20.04,
    height: 42
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 114.91,
    y1: 3.65,
    x2: 117.09,
    y2: 11.78
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 98.41,
    y1: 25.97,
    x2: 101.91,
    y2: 32.65
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-11",
    x1: 98.91,
    y1: 417.52,
    x2: 82.91,
    y2: 436.65
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m115.96,313.71c-9.38.44-18.36,1.14-26.89,2.02-9.4.98-18.28,2.18-26.57,3.5-.17.03-.33.05-.5.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m98.91,303.82v2c5.52-.46,11.2-.84,17.05-1.11,6.49-.32,13.18-.5,20.04-.54v-2c-11.2.06-21.9.51-32.09,1.26-1.68.12-3.35.25-5,.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m126,302.55v1.81c3.28-.1,6.62-.16,10-.19v-1.8c-3.39.02-6.72.08-10,.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m98.91,345.82v73c1.41-.12,2.84-.23,4.27-.34.24,0,.48-.03.73-.05v-73c-1.68.12-3.35.25-5,.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m103.91,416.43v2c10.18-.74,20.89-1.2,32.09-1.26v-2c-9.7.05-19.03.4-27.97.98-1.38.09-2.76.18-4.12.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m98.91,345.82v2c1.65-.14,3.32-.27,5-.39.01,0,.02-.01.03,0,1.35-.1,2.72-.2,4.09-.28,1.38-.09,2.78-.18,4.18-.25,1.48-.09,2.96-.16,4.46-.23,1.34-.06,2.7-.12,4.05-.17,4.32-.16,8.72-.27,13.19-.32.49-.01.98-.01,1.48-.01h.61v-2c-6.87.04-13.55.22-20.04.53-4.1.19-8.11.44-12.05.73-1.68.12-3.35.25-5,.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m103.91,112.43v2c10.18-.74,20.89-1.2,32.09-1.26v-2c-11.2.06-21.91.51-32.09,1.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m136.01,110.16c-17.09.11-33.05,1.11-47.71,2.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m136.01,138.16c-11.2.07-21.91.53-32.09,1.27-1.68.12-3.35.25-5,.39-2.43.2-4.83.41-7.2.65-2.33.23-4.62.47-6.89.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m136,346.16c-.2,0-.41,0-.61.01-.5,0-.99,0-1.48.01-4.48.04-8.88.15-13.19.32-1.36.05-2.71.11-4.05.17-1.5.07-2.98.14-4.46.23-1.4.07-2.8.16-4.18.25-1.37.08-2.74.18-4.09.28-.01-.01-.02,0-.03,0-1.68.12-3.35.25-5,.39-3.3.27-6.54.57-9.72.9-1.35.14-2.68.28-4.01.43-7.88.88-15.38,1.92-22.45,3.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "m103.91,112.43v191c10.18-.75,20.89-1.2,32.09-1.26V111.17c-11.2.06-21.91.51-32.09,1.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "m103.91,44.65v55c11-1,19.93-1.99,32-2h.09v-53h-32.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m98.91,112.82v192.83l5-2V112.43c-1.14.08-2.28.17-3.4.26-.54.04-1.07.09-1.6.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "m103.91,345.43v73c10.19-.74,20.89-1.2,32.09-1.26v-73c-6.87.04-13.55.22-20.04.53-4.1.19-8.11.44-12.05.73Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "95.91 445.65 136 445.65 136 422.65 103.91 422.65 99.21 436.15 95.91 445.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "97.91 445.33 136 445.33 136 423.65 105.69 423.65 105.33 424.65 104.25 427.65 103.9 428.65 103.18 430.65 102.82 431.65 101.74 434.65 101.38 435.65 101.02 436.65 100.67 437.65 100.31 438.65 99.95 439.65 98.87 442.65 98.51 443.65 97.91 445.33"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 99.91,
    y: 32.65,
    width: 36.09,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 95.91,
    y: 445.65,
    width: 40.09,
    height: 2
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "97.76 449.65 103.17 454.65 118.91 454.65 125.91 449.65 97.76 449.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "103.02 449.65 104.64 454.65 107.12 454.65 105.5 449.65 103.02 449.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "107.02 449.65 108.64 454.65 110.12 454.65 108.5 449.65 107.02 449.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "107.49 425.65 136 425.65 136 424.65 107.84 424.65 107.49 425.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "106.8 427.65 136 427.65 136 426.65 107.15 426.65 106.8 427.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "106.13 429.65 136 429.65 136 428.65 106.48 428.65 106.13 429.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "105.44 431.65 136 431.65 136 430.65 105.78 430.65 105.44 431.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "104.76 433.65 136 433.65 136 432.65 105.1 432.65 104.76 433.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "104.07 435.65 136 435.65 136 434.65 104.41 434.65 104.07 435.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "103.39 437.65 136 437.65 136 436.65 103.72 436.65 103.39 437.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "102.7 439.65 136 439.65 136 438.65 103.05 438.65 102.7 439.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "102.02 441.65 136 441.65 136 440.65 102.36 440.65 102.02 441.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "101.33 443.65 136 443.65 136 442.65 101.67 442.65 101.33 443.65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "m34.91,231.49v15h4.5c4.01,0,7.29-3.15,7.48-7.11.02-.13.02-.26.02-.39,0-2.07-.84-3.94-2.2-5.3-1.36-1.36-3.23-2.2-5.3-2.2h-4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m39.41,231.49h-4.5v1.72h5.36c3.51,0,6.38,2.72,6.62,6.17.02-.13.02-.26.02-.39,0-2.07-.84-3.94-2.2-5.3-1.36-1.36-3.23-2.2-5.3-2.2Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 34.91,
    y1: 220.49,
    x2: 61.91,
    y2: 220.49
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 34.91,
    y1: 260.99,
    x2: 61.91,
    y2: 260.99
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "98.91 259.76 98.91 275.76 103.91 274.22 103.91 258.22 98.91 259.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "98.91 230.26 98.91 246.26 103.91 244.72 103.91 228.72 98.91 230.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "98.91 200.76 98.91 216.76 103.91 215.22 103.91 199.22 98.91 200.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "98.91 171.26 98.91 187.26 103.91 185.72 103.91 169.72 98.91 171.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "98.91 141.76 98.91 157.76 103.91 156.22 103.91 140.22 98.91 141.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "98.91 141.76 98.91 157.76 103.91 156.22 103.91 140.22 98.91 141.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "103.91 169.72 98.91 171.26 98.91 187.26 103.91 185.72 103.91 169.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "103.91 199.22 98.91 200.76 98.91 216.76 103.91 215.22 103.91 199.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "103.91 228.72 98.91 230.26 98.91 246.26 103.91 244.72 103.91 228.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "103.91 258.22 98.91 259.76 98.91 275.76 103.91 274.22 103.91 258.22"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-23",
    cx: 38.91,
    cy: 258.49,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-23",
    cx: 15.91,
    cy: 269.49,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-23",
    cx: 46.91,
    cy: 258.49,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-23",
    cx: 54.91,
    cy: 258.49,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-23",
    cx: 38.91,
    cy: 223.49,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-23",
    cx: 46.91,
    cy: 223.49,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-23",
    cx: 54.91,
    cy: 223.49,
    r: 1
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "102.91 99.99 103.91 99.99 103.91 44.99 102.91 45.99 102.91 99.99"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "61.88 190 70.97 194.4 80.55 174.6 71.24 170.09 70.83 170.96 79.24 175.03 70.49 193.1 62.29 189.13 61.88 190"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-36",
    cx: 76.1,
    cy: 175.77,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-36",
    cx: 68.91,
    cy: 190.62,
    r: 0.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "74.94 372.07 80.16 391.46 72.7 393.47 72.92 394.4 81.37 392.13 75.66 370.88 67.76 373 67.98 373.94 74.94 372.07"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-36",
    cx: 73.06,
    cy: 374.68,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-36",
    cx: 77.34,
    cy: 390.62,
    r: 0.5
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "136 295.87 129.96 295.87 127.96 295.87 127.96 268.47 127.96 268.15 127.96 213.66 127.96 212.17 127.96 140.47 127.96 138.27 127.96 113.87 129.96 113.87 136 113.87 136 295.87"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 127.96,
    y: 113.87,
    width: 2,
    height: 182,
    transform: "translate(257.92 409.73) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 114.96,
    y: 47.87,
    width: 8,
    height: 42,
    transform: "translate(237.92 137.73) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 114.96,
    y: 47.87,
    width: 2,
    height: 42,
    transform: "translate(231.92 137.73) rotate(180)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "136 406.87 129.96 406.87 127.96 406.87 127.96 349.15 127.96 347.87 129.96 347.87 136 347.87 136 406.87"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 127.96,
    y: 347.87,
    width: 2,
    height: 59,
    transform: "translate(257.92 754.73) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m126,302.55v1.81c3.28-.1,6.62-.16,10-.19v-1.8c-3.39.02-6.72.08-10,.18Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m267.5,385.97v-110.22c0-.81-.35-1.58-.96-2.11-3.52-3.07-13.27-10.46-27.6-10.63-.68,0-1.34,0-2,.03v-16.69h.09v-15h-.09v-11.34l-7.2-8.07c-.52-.59-1.28-.92-2.07-.91l-7.66.09-10.01-21.26-.41-.87-8.56-18.17-.41-.87-13.61-28.9-.34-.72h-.01l-3.13-27.65-9.82-86.67h.09l-.11-.13-.05-.55h-.34l-16.53-22.32h-.01l-4-3h-33.51l-4,3h-.01l-16.53,22.32h-.34l-.05.55-.11.13h.09l-9.82,86.67-3.13,27.65h-.01l-.34.72-13.61,28.9-.41.87-8.56,18.17-.41.87-10.01,21.26-7.66-.09c-.79-.01-1.55.32-2.07.91l-7.19,8.07v11.34h-.09v15h.09v16.69c-.66-.02-1.32-.04-2-.03-14.33.17-24.08,7.56-27.6,10.63-.61.53-.96,1.3-.96,2.11v110.22C1.65,387.45,0,389.17,0,391v17c0,2.1,2.15,4.05,5.82,5.66l.07.51h0s0,0,0,0c0,1.87,4.77,3.4,10.64,3.4,1.52,0,2.97-.1,4.28-.29.59.07,1.18.14,1.79.2l.19,1.31c0,1.72,4.38,3.12,9.78,3.12s9.78-1.4,9.78-3.12l.18-1.21c.78-.07,1.54-.15,2.29-.23,1.18.14,2.45.23,3.78.23,5.88,0,10.64-1.52,10.64-3.4v-.07c4.32-1.69,6.89-3.81,6.89-6.1v-17c0-1.61-1.27-3.13-3.51-4.48v-35.45l.23.97,5.04,20.81.22.94,4.73,19.53.22.93,10.1,41.75.18.18,18.86,18.82h18.04l7.77-5.82,7.99-.17,7.99.17,7.77,5.82h18.04l18.86-18.82.18-.18,10.1-41.75.22-.93,4.73-19.53.22-.94,5.04-20.81.23-.97v35.45c-2.24,1.35-3.51,2.87-3.51,4.48v17c0,2.3,2.57,4.41,6.88,6.1v.07c.01,1.88,4.78,3.4,10.65,3.4,1.33,0,2.61-.08,3.78-.23.75.09,1.52.16,2.29.23l.18,1.21c0,1.72,4.38,3.12,9.78,3.12s9.78-1.4,9.78-3.12l.19-1.31c.6-.06,1.2-.13,1.79-.2,1.31.18,2.75.29,4.28.29,5.87,0,10.64-1.53,10.64-3.4,0,0,0,0,0,0h0l.07-.51c3.67-1.61,5.82-3.56,5.82-5.66v-17c0-1.84-1.65-3.56-4.51-5.04Zm-213.47-117.65h8.11v5.72c-1.33-1.2-4.1-3.52-8.11-5.72Zm155.86,5.72v-5.72h8.11c-4.01,2.2-6.77,4.51-8.11,5.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m272,391v17c0,2.1-2.15,4.05-5.8,5.66l-.08.52c0,1.87-4.76,3.4-10.62,3.4-1.52,0-2.96-.11-4.27-.29-.58.07-1.18.14-1.78.2l-.19,1.31c0,1.72-4.37,3.12-9.76,3.12s-9.76-1.4-9.76-3.12l-.18-1.22c-.77-.07-1.53-.14-2.28-.23-1.18.14-2.45.22-3.78.22-5.87,0-10.62-1.52-10.62-3.39v-.08c-4.31-1.69-6.88-3.8-6.88-6.1v-9.47c30.67-30.57,52.43-74.94,59.51-125.77.39.32.73.61,1.03.87.61.53.96,1.3.96,2.11v110.22c2.86,1.48,4.5,3.2,4.5,5.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "m227.21,417.36c-.2.02-.41.03-.61.05.2-.02.4-.04.58-.06.01,0,.02,0,.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "m225.35,417.51c.43-.02.83-.06,1.25-.1-.41.04-.82.07-1.25.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "m225.37,241.96c.88.18,1.74.4,2.58.64-.84-.23-1.69-.45-2.58-.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "m249.4,417.49h.05l-.19,1.31c0,1.04-1.59,1.96-4.03,2.52,2.41-.58,3.98-1.49,3.98-2.52l.19-1.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "m231.72,243.88c.77.29,1.5.61,2.21.93-.71-.31-1.45-.63-2.21-.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "m236.02,245.84c.99.51,1.91,1.03,2.75,1.56-.85-.52-1.77-1.05-2.75-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "m242.11,249.67c-.4-.29-.82-.6-1.28-.92.46.31.88.62,1.28.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "m241.69,394.34c.32-.13.61-.26.88-.4-.26.14-.55.28-.88.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "m244.19,391.66h.01l-.08.52c0,.23-.07.46-.22.68.14-.22.21-.45.21-.68l.08-.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "m245.3,252.71c.1.24.16.5.18.77-.03-.27-.09-.52-.18-.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "m245.48,253.48c.02.08.02.17.02.26v110.22h-.01v-110.22c0-.09,0-.18-.01-.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "m66,397.29v10.71c0,2.3-2.57,4.41-6.87,6.1v.08c-.01,1.87-4.76,3.39-10.63,3.39-1.33,0-2.6-.08-3.78-.22-.75.09-1.51.16-2.28.23l-.18,1.22c0,1.72-4.37,3.12-9.76,3.12s-9.76-1.4-9.76-3.12l-.19-1.31c-.6-.06-1.2-.13-1.78-.2-1.31.18-2.75.29-4.27.29-5.86,0-10.62-1.53-10.62-3.4l-.08-.52C2.15,412.05,0,410.1,0,408v-17c0-1.84,1.64-3.56,4.5-5.04v-71.12c7.46,38.28,30.9,69.27,61.5,82.45Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 192.38,
    y: 152.69,
    width: 4.15,
    height: 28,
    rx: 2.08,
    ry: 2.08,
    transform: "translate(-51.82 96.35) rotate(-24.66)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 203.38,
    y: 287.69,
    width: 4.15,
    height: 28,
    rx: 2.08,
    ry: 2.08
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 240.38,
    y: 329.69,
    width: 3.15,
    height: 24,
    rx: 1.58,
    ry: 1.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 240.38,
    y: 319.69,
    width: 3.15,
    height: 8,
    rx: 1.58,
    ry: 1.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 207.38,
    y: 388.69,
    width: 3.15,
    height: 12,
    rx: 1.58,
    ry: 1.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 162.38,
    y: 349.69,
    width: 3.15,
    height: 12,
    rx: 1.58,
    ry: 1.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 162.93,
    y: 46.64,
    width: 3.15,
    height: 12,
    rx: 1.58,
    ry: 1.58
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "m145.62,0h-26.38l-3.99,3h-.01l-16.54,22.32h-.34l-.05.55-.11.13h.09l-9.82,86.67-3.13,27.65h-.01l-.34.72-13.6,28.9-.42.87-8.55,18.17-.41.87-10.01,21.26-7.66-.09c-.79-.01-1.55.32-2.07.91l-7.2,8.07v11.34h-.09v15h.09v11.78c.64.02,1.28.03,1.93.03,64.07,0,116-85.51,116-191,0-23.63-2.61-46.26-7.38-67.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "m237.02,246.34v-15h-.09v-11.34l-7.19-8.07c-.52-.59-1.29-.92-2.08-.91l-7.65.09-4.4-9.34c-8.98,107.76-60.46,190.38-122.61,190.38-7.24,0-14.33-1.12-21.23-3.27l1.08,4.44.22.93,10.1,41.75.18.18,18.86,18.82h18.04l7.76-5.82,7.99-.18,7.99.18,7.76,5.82h18.04l18.86-18.82.18-.18,10.1-41.75.22-.93,4.73-19.53.22-.94,5.04-20.81.23-.97.13-76.57c1.03-.97,4-3.65,8.59-6.17l1.91.14-.06,12.2c0,.82.66,1.48,1.47,1.48h4.78c.82,0,1.6-.38,2.11-1.02l8.3-10.48c.25-.32.39-.72.39-1.12l.02-7.22h-.09s0-15.96,0-15.96h.09Zm-27.14,27.7v-5.72h8.1c-4,2.2-6.77,4.51-8.1,5.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m166.09,31.65h-60.18l2.31-3.11c6.15,1.39,14.36,1.58,23.18.25,10.93-1.64,20.27-5.25,25.58-9.41l4.52,6.09.5.68,4.09,5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "m154,15.37c-5.29,1.74-12.08,2.78-19.5,2.78-6.31,0-12.17-.75-17.04-2.05l1.84-2.47c.46-.61,1.19-.98,1.96-.98h29.48c.77,0,1.5.37,1.96.98l1.3,1.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m267.5,385.96v-110.22c0-.81-.34-1.58-.96-2.11-3.36-2.94-12.41-9.84-25.73-10.56-.59-.04-1.2-.06-1.81-.07-.68-.01-1.34,0-2,.03v-3.79c.58,0,1.1-.16,1.48-.41.38-.26.61-.6.61-.99,0-.77-.94-1.39-2.09-1.39v-10.12h.09v-15h-.09v-7.09c.58,0,1.1-.16,1.48-.41.38-.26.61-.6.61-.99,0-.77-.94-1.39-2.09-1.39v-1.46l-7.17-8.07c-.53-.59-1.29-.92-2.08-.91l-7.64.09-9.99-21.26-.41-.87-8.54-18.17-.41-.87-13.58-28.9-.34-.72-3.13-27.65-.17-1.49c.92-.18,1.58-.76,1.55-1.42-.03-.71-.84-1.24-1.86-1.29l-7.27-64.41c.69-.25,1.15-.75,1.13-1.3-.03-.6-.62-1.08-1.42-1.24l-1.75-15.52h.08l-.1-.13-.06-.55h-.34l-16.5-22.31h0S153,0,153,0h-34l-4,2.99h0s-16.5,22.32-16.5,22.32h-.34l-.06.55-.1.13h.08l-1.75,15.52c-.8.16-1.39.64-1.42,1.24-.02.55.44,1.05,1.13,1.3l-7.28,64.41c-1.01.05-1.82.58-1.85,1.29-.03.66.63,1.24,1.55,1.42l-.17,1.49-3.13,27.65h0l-.34.72-13.58,28.9-.41.87-8.54,18.17-.41.87-9.99,21.26-7.64-.09c-.79-.01-1.54.32-2.07.91l-7.17,8.07v1.46c-.58,0-1.1.16-1.48.41s-.61.59-.61.98c0,.77.93,1.4,2.09,1.4v7.09h-.1v15h.1v10.12c-.58,0-1.1.16-1.48.41s-.61.59-.61.98c0,.77.93,1.4,2.09,1.4v3.79c-.66-.03-1.32-.04-2-.03-.61.01-1.22.03-1.81.07-13.32.72-22.37,7.62-25.73,10.56-.62.53-.96,1.3-.96,2.11v17.32h-.01v16.01h.01v55.99h-.01v16.01h.01v4.89C1.64,387.44,0,389.16,0,391v17c0,2.1,2.14,4.05,5.8,5.66l.07.51c0,.94,1.19,1.78,3.11,2.4,1.92.62,4.58,1,7.51,1,1.52,0,2.97-.1,4.27-.28.59.07,1.18.13,1.79.19l.19,1.31c0,1.73,4.37,3.13,9.76,3.13s9.76-1.4,9.76-3.13l.17-1.21c.78-.07,1.54-.15,2.29-.23,1.18.14,2.44.22,3.78.22,5.86,0,10.62-1.52,10.62-3.4v-.07c4.31-1.69,6.88-3.8,6.88-6.1v-17c0-1.61-1.27-3.13-3.5-4.48v-35.44l.22.95,5.03,20.81.22.94,4.72,19.53.22.93,10.08,41.75h.01l19,19h18l7.75-5.82,8.25-.18,8.25.18,7.75,5.82h18l19-19,10.08-41.75.22-.93,4.72-19.53.22-.94,5.03-20.81.23-.95v35.44c-2.23,1.35-3.5,2.87-3.5,4.48v17c0,2.3,2.57,4.41,6.87,6.1v.07c.01,1.88,4.76,3.4,10.63,3.4,1.33,0,2.6-.08,3.78-.22.75.08,1.51.16,2.29.23l.17,1.21c0,1.73,4.37,3.13,9.76,3.13s9.76-1.4,9.76-3.13l.19-1.31c.6-.06,1.2-.12,1.78-.19,1.31.18,2.75.28,4.27.28,5.86,0,10.62-1.53,10.62-3.4l.08-.51c3.66-1.61,5.8-3.56,5.8-5.66v-17c0-1.84-1.64-3.56-4.5-5.04Zm-205.51-111.93c-1.33-1.2-4.09-3.52-8.09-5.72h8.09v5.72Zm148.01,0v-5.72h8.1c-4,2.2-6.76,4.52-8.1,5.72Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpaceshipBlue);
export default __webpack_public_path__ + "static/media/spaceship_blue.724773233ca91f7422ea890b44b2a513.svg";
export { ForwardRef as ReactComponent };